import AppShell from "../shared/AppShell";
import StoryView from "../story/StoryView";

const Story: React.FC = () => {

  return (
    <AppShell>
      <StoryView />
    </AppShell>
  );
};

export default Story;
